export const headerAccountId = 'X-Coorum-Research-Account-Id'
export const headerSessionKey = 'X-Coorum-Research-Session-Key'
export const headerUserKey = 'X-Coorum-Research-User-Key'
export const cookieNameAccountId = 'research-cur-acc'
